import { Map, Record } from 'immutable';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  LoadLayouts, DefaultTabSelection, TabClick, ShowRightSideSplitter,
  AllTilesRequested, AllTilesLoaded, IsHeaderMenuVisible, RoutedTab
} from '../actions/layout.actions';
import { createReducer, on, State, Action } from '@ngrx/store';

export interface TilesState extends EntityState<any> {
  allTilesLoaded: boolean;
}
export const tileAdapter: EntityAdapter<any> =
  createEntityAdapter<any>();
export const initialTilesState: TilesState = tileAdapter.getInitialState({
  allTilesLoaded: false
});
export interface LayoutState {
  tiles: TilesState;
  isRightPanelOpen: boolean;
  defaultTabSelection: string;
  routedTab: string,
  selectedTile: any;
  isHeaderVisible: boolean;
}

export const LayoutStateRecord: LayoutState = {
  tiles: initialTilesState,
  isRightPanelOpen: true,
  defaultTabSelection: localStorage.getItem("currentGrid"),
  routedTab: localStorage.getItem("currentGrid"),
  selectedTile: null,
  isHeaderVisible: true
};
const layoutReducer = createReducer(
  LayoutStateRecord,
  on(AllTilesLoaded, (state, { tiles }) => {
    return {
      ...state,
      tiles: tileAdapter.addAll(tiles, LayoutStateRecord.tiles),
      allTilesLoaded: true
    };
  }),
  on(TabClick, (state, { selectedTile }) => {
    return {
      ...state,
      selectedTile
    };
  }),
  on(ShowRightSideSplitter, (state, { isOpen }) => {
    return {
      ...state,
      isRightPanelOpen: isOpen
    };
  }),
  on(IsHeaderMenuVisible, (state, { isVisible }) => {
    return {
      ...state,
      isHeaderVisible: isVisible
    };
  }),
  on(RoutedTab, (state, { routedTab }) => {
    return {
      ...state,
      routedTab: routedTab
    };
  }),
);
export function reducer(state: LayoutState | undefined, action: Action) {
  return layoutReducer(state, action);
}
export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,

} = tileAdapter.getSelectors();

export const selectTilesIds = selectIds;

export const selectTileEntities = selectEntities;

export const selectAllTiles = selectAll;

export const selectTileTotal = selectTotal;
